import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@client/components/ui/dialog';
import { AdvisorHierarchyConsentDialog } from './AdvisorHierarchyConsentDialog';

interface ConsentData {
  hasConsented: boolean;
  ipAddress: string | null;
  userAgent: string;
}

interface AcceptInvitationDialogProps {
  open: boolean;
  invitation: PendingSupervisorInvitation | null;
  onAccept: (consentData: ConsentData) => void;
  onDecline: () => void;
  isSubmitting?: boolean;
}

export function AcceptInvitationDialog({
  open,
  invitation,
  onAccept,
  onDecline,
  isSubmitting = false,
}: AcceptInvitationDialogProps) {
  if (!invitation) {
    return null;
  }

  const supervisorName =
    invitation.supervisorFirstName && invitation.supervisorLastName
      ? `${invitation.supervisorFirstName} ${invitation.supervisorLastName}`
      : invitation.supervisorEmail;

  const supervisorOrgName =
    invitation.supervisorOrganizationDisplayName || invitation.supervisorOrganizationName;

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen && !isSubmitting) {
          onDecline();
        }
      }}
    >
      <DialogContent className="max-h-[90vh] max-w-lg overflow-y-auto">
        <DialogHeader className="sr-only">
          <DialogTitle>Accept Invitation</DialogTitle>
          <DialogDescription>
            Review and accept the invitation to join this organization
          </DialogDescription>
        </DialogHeader>
        <AdvisorHierarchyConsentDialog
          supervisorName={supervisorName}
          supervisorOrgName={supervisorOrgName}
          accessMode={invitation.accessMode}
          onAccept={onAccept}
          onDecline={onDecline}
          isSubmitting={isSubmitting}
        />
      </DialogContent>
    </Dialog>
  );
}
